<script lang="ts">
    import {
        COMMON__loading,
        ERROR__networkError__message,
    } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import type { LanguageDescriptionCarrier } from "models/api";
    import { dictionary } from "services/currentDictionary.service";
    import { getLanguageDescription } from "services/glosbe-dictionary-api/get-language-description";
    import { fade, slide } from "svelte/transition";
    import { keyboardActive } from "./Search.store";

    export let input: HTMLInputElement | HTMLTextAreaElement;
    export let inline: boolean = false;
    let keys: Promise<LanguageDescriptionCarrier> = undefined;

    function onClick(event: Event) {
        const key = (event.currentTarget as HTMLButtonElement).dataset["char"];

        input.focus();

        if (document["selection"]) {
            const selection = document["selection"].createRange();

            selection.text = key;

            input.focus();
        } else if (input.selectionStart || input.selectionStart === 0) {
            const startPos = input.selectionStart;
            const endPos = input.selectionEnd;

            const startText = input.value.substring(0, startPos);
            const endText = input.value.substring(endPos, input.value.length);

            input.value = `${startText}${key}${endText}`;
            input.focus();

            input.selectionStart = startPos + key.length;
            input.selectionEnd = startPos + key.length;
        } else {
            input.value += key;

            input.focus();
        }
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent("input", false, true);
        input.dispatchEvent(evt);
    }
    let prevL1Language = $dictionary.l1;
    $: {
        const keyboardActiveClass = "keyboard-active";
        const bodyClassList = window.document.body.classList;
        if ($keyboardActive) {
            if (!keys) {
                keys = getLanguageDescription($dictionary.l1.code);
            }
            bodyClassList.add(keyboardActiveClass);
        } else {
            bodyClassList.remove(keyboardActiveClass);
        }
        if (prevL1Language != $dictionary.l1) {
            keys = getLanguageDescription($dictionary.l1.code);
            prevL1Language = $dictionary.l1;
        }
    }
</script>

{#if $keyboardActive}
    <div
        class="bg-white shadow {inline
            ? ''
            : 'absolute'}  p-1 left-0 right-0 z-10 overflow-y-auto
    text-gray-900"
        style="max-height: 30vh"
        transition:fade={{ duration: 150 }}
    >
        {#await keys}
            {getMessage(COMMON__loading)}
        {:then description}
            {#if description.specialCharacters}
                {#each description.specialCharacters as character}
                    <button
                        class="bg-gray-200 rounded shadow h-8 w-8 p-1 mr-1 mb-1 md:w-6 md:h-6 md:text-xs hover:bg-gray-100 transition-all duration-300"
                        data-char={character}
                        on:click={onClick}
                    >
                        {character}
                    </button>
                {/each}
            {/if}
        {:catch}
            {getMessage(ERROR__networkError__message)}
        {/await}
    </div>
{/if}
